// A day is a calendar key, not the browser's local midnight.
function dailyDateLabel(day) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(String(day))) return 'Tarih seç';
  const date = new Date(`${day}T12:00:00Z`);
  return Number.isFinite(date.getTime()) ? new Intl.DateTimeFormat('tr-TR', {day:'numeric',month:'long',year:'numeric',timeZone:'Europe/Istanbul'}).format(date) : 'Tarih seç';
}
module.exports={dailyDateLabel};
